import script from "./SingleProductTableBulkOperations.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProductTableBulkOperations.vue?vue&type=script&setup=true&lang=js"

import "./SingleProductTableBulkOperations.vue?vue&type=style&index=0&id=f781a6a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f781a6a6"]])

export default __exports__